import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading, user } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Check subscription/trial status from auth context
  if (user) {
    const hasActiveSubscription = user.subscriptionStatus === 'active';
    
    if (!hasActiveSubscription) {
      // Calculate trial end from trialEndDate or createdAt + 14 days
      let trialEnd = null;
      if (user.trialEndDate) {
        trialEnd = new Date(user.trialEndDate);
      } else if (user.createdAt) {
        trialEnd = new Date(new Date(user.createdAt).getTime() + 14 * 24 * 60 * 60 * 1000);
      }
      
      if (trialEnd && trialEnd <= new Date()) {
        return <Navigate to="/subscription-expired" replace />;
      }
    }
  }

  return children;
};

export default ProtectedRoute;
